import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalDataService {
  private static currentData: any = null;

  static setData(data: any): void {
    ModalDataService.currentData = data;
    console.log('ModalDataService - Data set:', data);
  }

  static getData(): any {
    console.log(
      'ModalDataService - Data retrieved:',
      ModalDataService.currentData
    );
    return ModalDataService.currentData;
  }

  static clearData(): void {
    ModalDataService.currentData = null;
    console.log('ModalDataService - Data cleared');
  }
}
